/**
 * WorkdayFloatingPill.js
 *
 * Fallback placement of the {@link module:components/workday/WorkdayHeaderPill} for module home screens that have NO
 * stack header and no shared TopBar / GreetingHeader to host it: the POS tab host (HomeScreen), Tables, Online, the Driver
 * tab host and the Mailer home. A small chip floats just above the bottom tab bar on the left edge. Every other screen gets the
 * pill inline (stack header, TopBar, GreetingHeader), so this renders only on the routes listed in {@link FLOATING_ROUTES}.
 *
 * @module components/workday/WorkdayFloatingPill
 */

import React from 'react';
import {StyleSheet, View} from 'react-native';
import WorkdayHeaderPill from './WorkdayHeaderPill';
import {useBottomInset} from '../../helpers/safeArea';

/** Home routes that host no inline pill. */
export const FLOATING_ROUTES = Object.freeze({
    HomeScreen: 62,
    TablesScreen: 62,
    OnlineScreen: 62,
    DriverHomeScreen: 68 + 10 + 8,
    MailHomeScreen: 64,
});

/**
 * @param {{routeName: string}} props current route name.
 * @returns {JSX.Element|null} floating chip, or null on routes that already host the pill inline.
 */
export default function WorkdayFloatingPill({routeName}) {
    const bottomInset = useBottomInset();
    const barHeight = FLOATING_ROUTES[routeName];

    if (!barHeight) {
        return null;
    }

    return (
        <View pointerEvents="box-none" style={[styles.layer, {bottom: barHeight + bottomInset + 12}]}>
            <WorkdayHeaderPill compact />
        </View>
    );
}

const styles = StyleSheet.create({
    layer: {position: 'absolute', left: 14, zIndex: 50, elevation: 6},
});
